import React from 'react';
import { Card } from './ui/card';
import { Calendar, ArrowRight } from 'lucide-react';
import Tilt from 'react-parallax-tilt';
import '../styles/certifications.css';

const Certifications = ({ isVisible }) => {
  const certifications = [
    {
      title: 'Software Engineering Job Simulation',
      organization: 'JPMorgan Chase & Co. / Forage',
      date: 'August 23rd, 2025',
      description: 'Completed practical tasks in Project Setup, Kafka Integration, H2 Integration, REST API Integration, and REST API Controller.',
      imageUrl: '/jpmorgan-cert.jpg',
      link: 'https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/Sj7temL583QAYpHXD/E6McHJDKsQYh79moz_Sj7temL583QAYpHXD_jDyiSWadubo7fjRun_1755974360980_completion_certificate.pdf',
    },
    {
      title: 'AI/ML Internship',
      organization: 'Ember Quest',
      date: '4 Months',
      description: 'Applied machine learning algorithms for real-world problem-solving. Gained hands-on experience in model development and Agile practices.',
      imageUrl: '/EmberQuest.jpg',
      link: '/EmberQuest.jpg',
    },
    {
      title: 'AI/ML Trainee',
      organization: 'Crystallize Technologies',
      date: '3 Months',
      description: 'Completed comprehensive AI/ML training covering advanced ML concepts, deep learning, and software development lifecycles (SDLC).',
      imageUrl: '/Crystallize.jpg',
      link: '/Crystallize.jpg',
    },
    {
      title: 'Internship Complition Certificate',
      organization: 'Hindustan Aeronautics Limited',
      date: '2023',
      description: 'Completed hands-on internship at HAL gaining practical exposure to aerospace systems and industrial engineering workflows.',
      imageUrl: '/hal-cert.jpg',
      link: '#',
    },
    {
      title: 'Developer and Technology Job Simulation',
      organization: 'Accenture / Forage',
      date: 'August 23rd, 2025',
      description: 'Completed tasks: Discover Career Opportunities in Technology, SDLC, Waterfall and Agile, STLC, Algorithmic Thinking, and Code Debugging.',
      imageUrl: '/accenture-cert.jpg',
      link: 'https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/ovyvuqqNRQKBjNxbj/3xnZEj9kfpoQKW885_ovyvuqqNRQKBjNxbj_jDyiSWadubo7fjRun_1755970293495_completion_certificate.pdf',
    },
    {
      title: 'Solutions Architecture Job Simulation',
      organization: 'AWS / Forage',
      date: 'August 23rd, 2025',
      description: 'Completed practical tasks in: Designing a simple, scalable, hosting architecture.',
      imageUrl: '/aws-cert.jpg',
      link: 'https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/pmnMSL4QiQ9JCgE3W/kkE9HyeNcw6rwCRGw_pmnMSL4QiQ9JCgE3W_jDyiSWadubo7fjRun_1755966547332_completion_certificate.pdf',
    },
  ];

  return (
    <section id="certifications" className={`certifications ${isVisible ? 'visible' : ''}`}>
      <div className="certifications-container">
        <div className="section-header">
          <h2 className="section-title">Certifications</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Professional certifications and achievements (More to be added)
          </p>
        </div>

        <div className="certifications-grid">
          {certifications.map((cert, index) => (
            <Tilt 
              key={index}
              glareEnable={true}
              glareMaxOpacity={0.15}
              glareColor="#ffffff"
              glarePosition="all"
              scale={1.02}
              transitionSpeed={1500}
              tiltMaxAngleX={8}
              tiltMaxAngleY={8}
              style={{ animationDelay: `${index * 0.2}s` }}
              className="cert-tilt-wrapper"
            >
              <Card className="cert-card h-full">
                <div className="cert-image-container">
                  <img src={cert.imageUrl} alt={cert.title} className="cert-image" />
                </div>
                
                <div className="cert-content">
                  <h3 className="cert-title">{cert.title}</h3>
                  <div className="cert-org">{cert.organization}</div>
                  
                  <div className="cert-date">
                    <Calendar size={16} />
                    <span>{cert.date}</span>
                  </div>
                  
                  <p className="cert-description">{cert.description}</p>
                  
                  <a 
                    href={cert.link} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="cert-link"
                  >
                    View Certificate <ArrowRight size={16} />
                  </a>
                </div>
              </Card>
            </Tilt>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
